import styled from 'styled-components';
import theme from 'src/theme';
import { PrimaryButton } from 'src/styles/button.style';

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
`;

export const SectionMenuWrapper = styled.div`
    width: 120px;
    height: fit-content;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    margin-left: 5px;
    box-shadow: #ccc 0 2px 6px 2px;
`;

export const ReportContainer = styled.div`
    height: 99%;
    width: 99%;
    margin: 0 auto;

    iframe {
        border: 0;
    }
`;

export const PbiMenuPopover = styled.div`
    position: absolute;
    bottom: 8px;
    left: 58px;
    z-index: 999;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    color: ${theme.legacyColors.darkBlue};
    width: 10rem;
`;

export const PbiMenuItem = styled.div`
    position: relative;
    color: ${theme.legacyColors.darkBlue};
    background: ${theme.legacyColors.headingPanelBgColor};
    width: 100%;
    &:hover {
        background: #eee;
    }

    &.active-link {
        background: ${theme.legacyColors.selectedBackground};
        color: ${theme.legacyColors.selectedColor};
        border-bottom: 1px solid ${theme.legacyColors.selectedBorder};
    }
`;

export const NestedMenu = styled.div`
    border: 1px solid #ccc;
    width: 16rem;
    position: absolute;
    left: 100%;
    bottom: 0;
    z-index: 1000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: calc(100vh - 80px);
    overflow-y: auto;
`;

export const ReportLinkButton = styled(PrimaryButton)`
    width: 100%;
    height: fit-content;
`;
